// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgEmail24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 21 20"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g id="Layer_1" clipPath="url(#clip0_11434_9950)">
					<path
						id="Vector"
						d="M10.0632 -2.94305e-05C10.0632 -2.94305e-05 1.36992 -0.222075 0.0317788 9.10299C0.0317788 9.10299 -0.711445 15.3077 4.93605 18.5956C4.93605 18.5956 8.26086 20.9736 13.0168 19.5433L12.2552 17.11C12.2552 17.11 7.09869 18.9995 3.59875 13.8405C3.59875 13.8405 1.25847 9.97693 3.59875 6.24322C3.59875 6.24322 5.52593 2.62094 10.0054 2.54637C10.0054 2.54637 16.3793 2.4718 17.4192 9.19684C17.4192 9.19684 17.4561 9.47586 17.4561 9.8747V13.3855C17.4561 13.3855 17.3538 14.732 15.9512 14.732C14.5485 14.732 14.484 13.4316 14.484 13.4316V5.67176L11.9301 5.62987C11.9301 5.62987 9.325 4.38976 6.97049 6.29852C6.97049 6.29852 5.20083 7.66347 5.20083 10.0322C5.20083 10.0322 5.15893 12.763 7.79247 14.2813C7.79247 14.2813 9.56213 15.4099 12.0415 14.3508C12.0415 14.3508 12.8492 17.2902 16.0123 17.2902C16.0123 17.2902 19.5232 17.3597 20.0108 13.5841V9.11221C20.0108 9.11221 19.2307 0.418086 10.0632 -2.94305e-05ZM11.9652 11.1802C11.1366 12.2393 10.3422 12.2736 10.3422 12.2736H9.84786C7.61903 11.9812 7.74387 9.89816 7.74387 9.89816C7.93156 7.73134 10.0054 7.75229 10.0054 7.75229C11.501 7.80842 11.9652 8.84575 11.9652 8.84575V11.1793V11.1802Z"
					/>
				</g>
				<defs>
					<clipPath id="clip0_11434_9950">
						<rect width={20.0109} height={20} />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgEmail24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgEmail24;
